// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Wide screen: sidebar fixed outside the 1280px app-main ──── */
@media (min-width: 1920px) {
  .homepage-sidebar {
    position: fixed;
    right: 0;
    width: 320px;
    max-height: 100vh;
    overflow-y: auto;
    padding: 0 8px 24px;
    /* top is driven by inline style from scroll listener */
    z-index: 100;
    transition: top 0.1s linear;
  }

  .sidebar-toggle-btn {
    display: none;
  }

  .sidebar-overlay-backdrop {
    display: none;
  }
}

/* ── Narrow screen: sidebar as right-edge overlay ─────────────── */
@media (max-width: 1919px) {
  .homepage-sidebar {
    position: fixed;
    top: 0 !important; /* ignore inline scroll style */
    right: 0;
    width: 320px;
    height: 100dvh;
    background: var(--surface);
    border-left: 1px solid var(--border);
    padding: 16px;
    overflow-y: auto;
    transform: translateX(100%);
    transition: transform 0.25s ease;
    z-index: 500;
  }

  .homepage-sidebar.sidebar-overlay-open {
    transform: translateX(0);
  }

  /* Floating toggle tab on the right edge */
  .sidebar-toggle-btn {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: var(--secondary-color);
    color: #fff;
    border: none;
    border-radius: 8px 0 0 8px;
    padding: 14px 9px;
    cursor: pointer;
    z-index: 501;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);
  }

  .sidebar-toggle-btn:hover {
    filter: brightness(1.15);
  }

  .sidebar-overlay-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 499;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,uDAAuD;IACvD,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,eAAe;IACf,iBAAiB,EAAE,+BAA+B;IAClD,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,0BAA0B;IAC1B,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,gCAAgC;IAChC,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,0CAA0C;EAC1C;IACE,eAAe;IACf,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;EAC3C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,YAAY;EACd;AACF","sourcesContent":["/* ── Wide screen: sidebar fixed outside the 1280px app-main ──── */\r\n@media (min-width: 1920px) {\r\n  .homepage-sidebar {\r\n    position: fixed;\r\n    right: 0;\r\n    width: 320px;\r\n    max-height: 100vh;\r\n    overflow-y: auto;\r\n    padding: 0 8px 24px;\r\n    /* top is driven by inline style from scroll listener */\r\n    z-index: 100;\r\n    transition: top 0.1s linear;\r\n  }\r\n\r\n  .sidebar-toggle-btn {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar-overlay-backdrop {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* ── Narrow screen: sidebar as right-edge overlay ─────────────── */\r\n@media (max-width: 1919px) {\r\n  .homepage-sidebar {\r\n    position: fixed;\r\n    top: 0 !important; /* ignore inline scroll style */\r\n    right: 0;\r\n    width: 320px;\r\n    height: 100dvh;\r\n    background: var(--surface);\r\n    border-left: 1px solid var(--border);\r\n    padding: 16px;\r\n    overflow-y: auto;\r\n    transform: translateX(100%);\r\n    transition: transform 0.25s ease;\r\n    z-index: 500;\r\n  }\r\n\r\n  .homepage-sidebar.sidebar-overlay-open {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  /* Floating toggle tab on the right edge */\r\n  .sidebar-toggle-btn {\r\n    position: fixed;\r\n    right: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: var(--secondary-color);\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 8px 0 0 8px;\r\n    padding: 14px 9px;\r\n    cursor: pointer;\r\n    z-index: 501;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);\r\n  }\r\n\r\n  .sidebar-toggle-btn:hover {\r\n    filter: brightness(1.15);\r\n  }\r\n\r\n  .sidebar-overlay-backdrop {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.45);\r\n    z-index: 499;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
